import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApplicationReadinessService {
  private readonly contentReadyState = signal(false);

  readonly contentReady = this.contentReadyState.asReadonly();

  setContentReady(ready: boolean): void {
    this.contentReadyState.set(ready);
  }
}
